import { getFormById, submitForm } from "../../api/form";

const forms = {
    namespaced: true,
    state: {
        formData: null,
        loading: false,
        error: null,
        submissionSuccess: false,
    },
    mutations: {
        SET_FORM_DATA(state, data) {
            state.formData = data;
        },
        SET_LOADING(state, isLoading) {
            state.loading = isLoading;
        },
        SET_ERROR(state, error) {
            state.error = error;
        },
        SET_SUBMISSION_SUCCESS(state, success) {
            state.submissionSuccess = success;
        },
    },
    actions: {
        async fetchFormData({ commit }, { siteId, formId }) {
            commit("SET_LOADING", true);
            commit("SET_ERROR", null);
            return getFormById(siteId, formId)
                .then((response) => {
                    commit("SET_FORM_DATA", response.data);
                    commit("SET_LOADING", false);
                    return response.data;
                })
                .catch((error) => {
                    commit("SET_ERROR", error);
                    commit("SET_LOADING", false);
                    console.error("Error fetching form data:", error);
                    return false;
                });
        },
        async submitFormData({ commit }, { siteId, formData }) {
            commit("SET_LOADING", true);
            commit("SET_ERROR", null);
            commit("SET_SUBMISSION_SUCCESS", false);
            try {
                const response = await submitForm(siteId, formData);
                if (response.data.success) {
                    commit("SET_SUBMISSION_SUCCESS", true);
                } else {
                    commit("SET_ERROR", response.data.message);
                }
            } catch (error) {
                commit("SET_ERROR", error.response.data.message);
                console.error("Error submitting form data:", error);
            } finally {
                commit("SET_LOADING", false);
            }
        },
    },
    getters: {
        formData: (state) => state.formData,
        loading: (state) => state.loading,
        error: (state) => state.error,
        submissionSuccess: (state) => state.submissionSuccess,
    },
};

export default forms;
